import { apiFetch } from '../client';

const SECTION_NOTE_ACCEPT =
    '.jpg,.jpeg,.png,.gif,.webp,.bmp,.heic,.heif,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.txt,.rtf,.csv';
const SECTION_NOTE_MAX_BYTES = 100 * 1024 * 1024;

function appendFiles(formData, files) {
    files.forEach((file) => formData.append('files', file));
}

export function updateSection(editData, sectionID, propID) {
    return apiFetch("/map-api/user-update-sections/", {
        method: 'POST',
        body: JSON.stringify({...editData, nr: sectionID, propID: propID})
    })
}

export function createAdFromSection(sectID) {
    return apiFetch("/map-api/create-ad/", {
        method: 'POST',
        body: JSON.stringify({ sectID: sectID })
    })
}

export function sectionTools(sectionID, toolName) {
    return apiFetch("/map-api/user-section-tools/", {
        method: 'POST',
        body: JSON.stringify({
            sectionID: sectionID,
            action: toolName
        })
    })}

export function addSectionNote(sectionID, text, files = []) {
    const formData = new FormData();
    formData.append('nr', String(sectionID));
    formData.append('text', text || '');
    appendFiles(formData, files);
    return apiFetch('/map-api/section-note/add/', {
        method: 'POST',
        body: formData,
    });
}

export function updateSectionNote(noteId, text) {
    return apiFetch('/map-api/section-note/update/', {
        method: 'POST',
        body: JSON.stringify({ note_id: noteId, text: text }),
    });
}

export function addSectionNoteAttachment(noteId, files) {
    const formData = new FormData();
    formData.append('note_id', String(noteId));
    appendFiles(formData, files);
    return apiFetch('/map-api/section-note/attachment/add/', {
        method: 'POST',
        body: formData,
    });
}

export function deleteSectionNoteAttachment(attachmentId) {
    return apiFetch('/map-api/section-note/attachment/delete/', {
        method: 'POST',
        body: JSON.stringify({ attachment_id: attachmentId }),
    });
}

export function deleteSectionNote(noteId) {
    return apiFetch('/map-api/section-note/delete/', {
        method: 'POST',
        body: JSON.stringify({ note_id: noteId }),
    });
}

export { SECTION_NOTE_ACCEPT, SECTION_NOTE_MAX_BYTES };
